import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import PublicationViewer from '../components/PublicationViewer';

const PublicationView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [publication, setPublication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPublication = async () => {
      try {
        const response = await api.get(`/publications/${id}`);
        setPublication(response.data);
      } catch (error) {
        setError('Failed to load publication');
      } finally {
        setLoading(false);
      }
    };
    
    fetchPublication();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-600">Loading publication...</div>
      </div>
    );
  }

  if (error || !publication) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="text-red-600 mb-4">{error || 'Publication not found'}</div>
        <button
          onClick={() => navigate('/publications')}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Back to Publications
        </button>
      </div>
    );
  }

  // Get auth token for PDF request
  const token = localStorage.getItem('token');

  return <PublicationViewer publicationId={id} token={token} />;
};

export default PublicationView;
